import React, { useEffect, useState } from "react";
import { Backdrop, Box, CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import { ServiceApi } from "../services/index.service";
import MandatoryPromotions from "./MandatoryPromotions";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import AddPromotionDialog from "./AddPromotionDialog";
import dayjs from "dayjs";
import NonMandatoryPromotions from "./NonMandatoryPromotions";
import PropTypes from "prop-types";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const DMBPreSellBoardAdmin = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);
  // const [promotionList, setPromotionList] = useState([]);
  const [mandatoryList, setMandatoryList] = useState([]);
  const [nonMandatoryList, setNonMandatoryList] = useState([]);
  const [value, setValue] = useState(0);

  const initival = {
    intBannerID: 0,
    vchBannerName: "",
    vchBannerURL: "",
    bitActive: 0,
    bitMandatory: 0,
    dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitBannerType: 2,
    dteDateCreated: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    bitVertical: 1,
  };
  const [selectedPromotion, setSelectedPromotion] = useState(initival);
  const [action, setAction] = useState("Add");
  const [showDialog, setShowDialog] = useState(false);
  const data = useSelector((state) => state);

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedPromotion(initival);
    setAction("Add");
  };
  const handleEdit = (dataItem) => {
    setAction("Update");
    setSelectedPromotion(dataItem);
    setShowDialog(true);
  };
  const handleDelete = async (dataItem) => {
    console.log(dataItem);
    let req = {
      intBannerID: dataItem?.intBannerID,
      action:'delete',
      vchBannerName:dataItem?.vchBannerName,
      vchBannerURL:dataItem?.vchBannerURL
    };
    setBtnLoading(true);
    const res = await serviceapi.savePresellBoardAdmin(req);
    console.log(res);
    setBtnLoading(false);
    if (res?.success) {
      const message = "Promotion Deleted Successfully";
      setSelectedPromotion(initival);
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      fetchPresellOrderList();
    } else {
      const message = "Error in Deleting Promotion";
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };
  const serviceapi = new ServiceApi();

  useEffect(() => {
    fetchPresellOrderList();
  }, [props?.success]);

  const fetchPresellOrderList = async () => {
    const req = {
      role: data?.profile?.role,
      user_name: data?.profile?.user_name,
      bitBannerType: 2,
    };
    setLoading(true);
    const res = await serviceapi.fetchPresellOrderList(req);
    setLoading(false);
    const result = res?.data;
    // setPromotionList([...result?.mandatory, ...result?.nonMandatory]);
    setMandatoryList(result?.mandatory);
    setNonMandatoryList(result?.nonMandatory);
   
  };

  const handlePromotion = (value, name) => {
    if (name === "Mandatory" && !value) {
      setSelectedPromotion({
        ...selectedPromotion,
        [name]: value,
        StartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        EndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      });
    } else {
      setSelectedPromotion({ ...selectedPromotion, [name]: value });
    }
  };
  const tabsList = [
    {
      id: 1,
      title: "Mandatory",
      label: "Mandatory",
      disabled: false,
    },
    {
      id: 2,
      label: "Non-Mandatory",
      title: "Non-Mandatory",
      disabled: false,
    },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onSubmit = async () => {
    console.log(selectedPromotion);
    let req = {
      ...selectedPromotion,
      vchBannerName: selectedPromotion?.vchBannerName,
      vchBannerURL: selectedPromotion?.vchBannerURL,
      bitActive: selectedPromotion?.bitActive ? 1 : 0,
      bitMandatory: selectedPromotion?.bitMandatory ? 1 : 0,
      dteStartDate: selectedPromotion?.bitMandatory
        ? dayjs(selectedPromotion?.dteStartDate).format('YYYY-MM-DD HH:mm:ss')
        : dayjs().format('YYYY-MM-DD HH:mm:ss'),
      dteEndDate: selectedPromotion?.bitMandatory
        ? dayjs(selectedPromotion?.dteEndDate).format('YYYY-MM-DD HH:mm:ss')
        : dayjs().format('YYYY-MM-DD HH:mm:ss'),
      bitBannerType: 2,
      bitVertical: selectedPromotion?.bitVertical ? 1 : 0,
    };
    setBtnLoading(true);
    if (action === "Add") {
      req = { ...req, intBannerID: 0 };
    }
    const res = await serviceapi.savePresellBoardAdmin(req);
    console.log(res);
    setBtnLoading(false);
    if (res?.success) {
      let message = "Promotion Added Successfully";
      if (action === "Update") {
        message = "Promotion Updated Successfully";
      }
      setShowDialog(false);
      setSelectedPromotion(initival);
      fetchPresellOrderList();
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
    } else {
      let message = "Error in Adding Promotion";
      if (action === "Update") {
        message = "Error in Updating Promotion";
      }
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
    // setPromotionsList(records);
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading || btnloading}
        onClick={handleCloseDialog}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <main>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange}>
            {tabsList?.map((itm, index) => (
              <Tab
                label={itm.label}
                {...a11yProps(itm.id)}
                key={itm.id}
                disabled={itm.disabled}
              />
            ))}
          </Tabs>
        </Box>
        {tabsList?.map((tabItem, index) => {
          return (
            <TabPanel key={tabItem.id} value={value} index={index}>
              {tabItem.id === 1 && (
                <MandatoryPromotions
                  loading={loading}
                  IsAdmin={true}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  promotionsList={mandatoryList}
                  dmb={true}

                  // handleUpdateOrder={handleUpdateOrder}
                />
              )}
              {tabItem.id === 2 && (
                <NonMandatoryPromotions
                  loading={loading}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  IsAdmin={true}
                  promotionsList={nonMandatoryList}
                  // handleUpdateOrder={handleUpdateOrder}
                  dmb={true}
                />
              )}
            </TabPanel>
          );
        })}
      </main>
      {showDialog ? (
        <AddPromotionDialog
          showDialog={showDialog}
          IsAdmin={true}
          handleCloseDialog={handleCloseDialog}
          action={action}
          selectedPromotion={selectedPromotion}
          handlePromotion={handlePromotion}
          btnloading={btnloading}
          onSubmit={onSubmit}
          setSelectedPromotion={setSelectedPromotion}
        />
      ) : null}
    </>
  );
};

export default DMBPreSellBoardAdmin;
